import * as React from 'react';

const GoalVisitPage = ({ size }: { size?: number }) => (
  <svg
    width={size || 40}
    height={size || 40}
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M64.4 19.6c-.6-.6-1.3-.9-2.1-.9H18.5c-.8 0-1.5.3-2.1.9-.6.5-.9 1.3-.9 2.1v30.8c0 .8.3 1.5.9 2.1.5.6 1.3.9 2.1.9h15.6v3H30c-2.5 0-4.6 2-4.6 4.6h30.1c0-2.5-2-4.6-4.6-4.6h-4.1v-3h15.6c.8 0 1.5-.3 2.1-.9.5-.5.9-1.3.9-2.1V21.7c-.1-.8-.4-1.5-1-2.1zm-5 30h-38V24.7h38v24.9zm-16.3-7.7c.1.4.4.6.8.7h.1c.3 0 .6-.2.8-.4l1.3-2 3 4.2c.2.3.5.4.8.4.2 0 .4-.1.5-.2l1.1-.8c.2-.1.3-.4.4-.6 0-.2 0-.5-.2-.7l-3-4.2 2.3-.6c.4-.1.6-.4.7-.8.1-.4-.1-.7-.4-.9l-9.5-5.8c-.3-.2-.7-.2-1 0-.3.2-.4.6-.4 1l2.7 10.7z" />
  </svg>
);

export default GoalVisitPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Icon/GoalVisitPage.tsx